import React, { Component } from "react";
import axios from "axios";

class VenversSyncSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            syncProviders: false,
            loading: true,
            saving: false,
            message: null,
            error: null,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        this.setState({ loading: true }, () => {
            axios
                .get("/api/venvers/settings")
                .then((res) => {
                    if (!this._isMounted) return;
                    this.setState({
                        syncProviders: !!res.data.sync_providers,
                    });
                })
                .catch(() => {
                    if (!this._isMounted) return;
                    this.setState({
                        error: "No se pudo cargar la configuración de Venvers.",
                    });
                })
                .finally(() => {
                    if (!this._isMounted) return;
                    this.setState({ loading: false });
                });
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleChange(e) {
        const newValue = e.target.checked;

        this.setState({
            syncProviders: newValue,
            saving: true,
            message: null,
            error: null,
        });

        axios
            .post("/api/venvers/settings", {
                sync_providers: newValue,
            })
            .then((res) => {
                this.setState({
                    message: "Configuración actualizada correctamente.",
                    syncProviders: !!res.data.sync_providers,
                });
            })
            .catch(() => {
                this.setState((prevState) => ({
                    error: "No se pudo guardar la configuración.",
                    syncProviders: !newValue,
                }));
            })
            .finally(() => {
                this.setState({ saving: false });
            });
    }

    render() {
        const { syncProviders, loading, saving, message, error } = this.state;

        return (
            <div className="card card-custom gutter-b my-5">
                <div className="card-header border-0 pt-6">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">
                            Venvers - Configuración
                        </span>
 
                    </h3>
                </div>
                <div className="card-body pt-5">
                    {loading ? (
                        <p>Cargando configuración...</p>
                    ) : (
                        <div className="form-group mb-5">
                            <div className="checkbox-inline form-group">
                                <label className="checkbox checkbox-lg checkbox-square">
                                    <input
                                        type="checkbox"
                                        name="sync_providers"
                                        checked={syncProviders}
                                        onChange={this.handleChange}
                                        disabled={saving} 
                                    />
                                    <span></span>
                                    Sincronizar proveedores con People Soft
                                </label>
                            </div>
                            {saving && (
                                <p className="text-muted mt-2">Guardando cambios...</p>
                            )}
                            {message && (
                                <div className="alert alert-success mt-3" role="alert">
                                    {message}
                                </div>
                            )}
                            {error && (
                                <div className="alert alert-danger mt-3" role="alert">
                                    {error}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default VenversSyncSettings;
